module.exports = __webpack_public_path__ + "media/thieme/Radiology_Flashcards_1024x1536px_k2-349fdb7c.jpg";